import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from "../../components/Navbar";
import { API, BASE_URL } from "../../api";
const API_BASE = API;
// const API_BASE = 'http://localhost:5000/api';
// const API_BASE = "http://192.168.0.57:5000/api";
const T = {
  bg:        '#0d0d0d',
  // bgCard:    '#141414',
  bgCard:    'rgb(10, 14, 23)',
  border:    'rgba(201,168,76,0.18)',
  borderHov: 'rgba(201,168,76,0.5)',
  gold:      '#C9A84C',
  goldLight: '#e8cc80',
  cream:     '#f0e6cc',
  textMuted: 'rgba(240,230,204,0.45)',
  textSub:   'rgba(240,230,204,0.65)',
};


// ─── FORM INPUT ───────────────────────────────────────────────
function Field({ label, icon, error, children }) {
  return (
    <div style={{ display:'flex',flexDirection:'column',gap:'6px' }}>
      <label style={{ color:T.textMuted,fontSize:'0.72rem',letterSpacing:'0.12em',textTransform:'uppercase',fontWeight:'600' }}>
        {icon} {label}
      </label>
      {children}
      {error && <span style={{ color:'#e87c7c',fontSize:'0.75rem' }}>{error}</span>}
    </div>
  );
}

function Input({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <input
      {...props}
      onFocus={e => { setFocused(true); props.onFocus?.(e); }}
      onBlur={e => { setFocused(false); props.onBlur?.(e); }}
      style={{
        background:'rgba(255,255,255,0.04)',
        border:`1px solid ${focused ? T.gold : T.border}`,
        borderRadius:'5px',
        color:T.cream,
        padding:'11px 14px',
        fontSize:'0.9rem',
        outline:'none',
        width:'100%',
        transition:'border-color 0.2s',
        ...style,
      }}
    />
  );
}

function Textarea({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <textarea
      {...props}
      onFocus={e => { setFocused(true); props.onFocus?.(e); }}
      onBlur={e => { setFocused(false); props.onBlur?.(e); }}
      style={{
        background:'rgba(255,255,255,0.04)',
        border:`1px solid ${focused ? T.gold : T.border}`,
        borderRadius:'5px',
        color:T.cream,
        padding:'11px 14px',
        fontSize:'0.9rem',
        outline:'none',
        width:'100%',
        resize:'vertical',
        minHeight:'110px',
        fontFamily:'inherit',
        transition:'border-color 0.2s',
        ...style,
      }}
    />
  );
}

// ─── CONTACT PAGE ─────────────────────────────────────────────
const ContactUs = () => {
  const [form, setForm]         = useState({ name:'', email:'', phone:'', message:'', otp:'' });
  const [errors, setErrors]     = useState({});
  const [otpSent, setOtpSent]   = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [sending, setSending]   = useState(false);
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [serverError, setServerError] = useState('');

  useEffect(() => {
    const s = document.createElement('style');
    s.id = 'contact-styles';
    if (!document.getElementById('contact-styles')) {
      s.innerHTML = `
        @keyframes spin    { to { transform: rotate(360deg); } }
        @keyframes fadeUp  { from { opacity:0;transform:translateY(18px); } to { opacity:1;transform:translateY(0); } }
        @keyframes pulse   { 0%,100%{opacity:1;} 50%{opacity:0.5;} }
        .con-animate { animation: fadeUp 0.55s ease both; }
        ::placeholder { color: rgba(240,230,204,0.25) !important; }
        @media(max-width:768px){
          .mob-nav-toggle { display:flex !important; }
          .desk-nav-ul    { display:none !important; }
          .desk-nav-cta   { display:none !important; }
          .con-grid       { grid-template-columns:1fr !important; }
          .con-hero-h1    { font-size:2rem !important; }
        }
      `;
      document.head.appendChild(s);
    }
  }, []);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required';
    if (!form.email.trim())   e.email   = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Invalid email';
    if (!form.phone.trim())   e.phone   = 'Phone number is required';
    else if (!/^[0-9]{8,15}$/.test(form.phone)) e.phone = 'Enter a valid phone number';
    if (!form.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleSendOtp = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setOtpSending(true); setServerError('');
    try {
      await axios.post(`${API_BASE}/contact/send-otp`, { email: form.email });
      setOtpSent(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Failed to send OTP');
    }
    setOtpSending(false);
  };

  const handleVerifyOtp = async () => {
    if (!form.otp.trim()) { setErrors(p=>({...p,otp:'Enter the OTP'})); return; }
    setOtpVerifying(true); setServerError('');
    try {
      await axios.post(`${API_BASE}/contact/verify-otp`, { email: form.email, otp: form.otp });
      setOtpVerified(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Invalid OTP');
      setErrors(p=>({...p,otp:'Invalid or expired OTP'}));
    }
    setOtpVerifying(false);
  };

  const handleSubmit = async () => {
    if (!otpVerified) { setServerError('Please verify OTP first'); return; }
    setSending(true); setServerError('');
    try {
      await axios.post(`${API_BASE}/contact/submit`, {
        name: form.name, email: form.email,
        phone: form.phone, message: form.message, otp: form.otp,
      });
      setSubmitted(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Failed to send message');
    }
    setSending(false);
  };

  const set = (k) => (e) => {
    setForm(p => ({ ...p, [k]: e.target.value }));
    setErrors(p => ({ ...p, [k]: '' }));
  };

  return (
    <div style={{ background:T.bg,minHeight:'100vh',fontFamily:"'Segoe UI',sans-serif" }}>
      {/* <Navbar siteName="Drive" /> */}
      <Navbar activePage="Contact" siteName="-Fleet" />
      {/* ── HERO ── */}
      <div style={{
        paddingTop:'64px',
        // background:'linear-gradient(180deg,#111 0%,#0d0d0d 100%)',
        background: `linear-gradient(rgb(9, 9, 15) 0%, rgb(10, 14, 23) 100%)`,
        borderBottom:`1px solid ${T.border}`,
      }}>
        <div style={{ maxWidth:'960px',margin:'0 auto',padding:'64px 2rem 52px' }}>
          <p style={{ color:T.gold,fontSize:'0.72rem',letterSpacing:'0.28em',textTransform:'uppercase',fontWeight:'600',margin:'0 0 14px' }}>
            Get In Touch
          </p>
          <h1 className="con-hero-h1" style={{
            margin:'0 0 20px',fontFamily:'Georgia,serif',
            fontSize:'3.2rem',fontWeight:'700',color:'#fff',lineHeight:1.15,
          }}>
            Contact <span style={{ color:T.gold }}>Us</span>
          </h1>
          <div style={{ width:'48px',height:'3px',borderRadius:'2px',background:`linear-gradient(90deg,${T.gold},${T.goldLight})`,marginBottom:'20px' }} />
          <p style={{ color:T.textMuted,fontSize:'0.83rem',margin:0 }}>
            Home &rsaquo; <span style={{ color:T.gold }}>Contact Us</span>
          </p>
        </div>
      </div>

      {/* ── BODY ── */}
      <div style={{ background:'rgb(9, 9, 15)' }}>
        <div style={{ maxWidth:'960px',margin:'0 auto',padding:'56px 2rem 72px' }}>

          {/* Info strip */}
          <div style={{
            border:`1px solid ${T.border}`,borderLeft:`3px solid ${T.gold}`,
            background:'rgba(201,168,76,0.05)',borderRadius:'6px',
            padding:'14px 20px',marginBottom:'2.5rem',
            display:'flex',alignItems:'center',gap:'12px',
          }}>
            <span style={{ color:T.gold,fontSize:'1.1rem' }}>⚠</span>
            <p style={{ margin:0,color:T.textSub,fontSize:'0.87rem',lineHeight:1.6 }}>
              Please verify your email with an OTP before submitting.{' '}
              <strong style={{ color:T.goldLight }}>Fill the form, click Send OTP, verify, then submit.</strong>
            </p>
          </div>

          {/* Success state */}
          {submitted ? (
            <div className="con-animate" style={{
              textAlign:'center',padding:'4rem 2rem',
              border:`1px solid rgba(80,200,120,0.3)`,
              borderRadius:'8px',background:'rgba(80,200,120,0.05)',
            }}>
              <div style={{ fontSize:'3rem',marginBottom:'1rem' }}>✓</div>
              <h2 style={{ color:'#6ee7a0',fontFamily:'Georgia,serif',margin:'0 0 10px' }}>Message Sent!</h2>
              <p style={{ color:T.textSub,margin:0 }}>We'll get back to you as soon as possible.</p>
            </div>
          ) : (

          <div className="con-grid con-animate" style={{
            display:'grid',gridTemplateColumns:'1fr 1fr',gap:'2rem',
          }}>

            {/* ── LEFT: Form ── */}
            <div style={{
              background:T.bgCard,border:`1px solid ${T.border}`,
              borderRadius:'8px',padding:'2rem',
              display:'flex',flexDirection:'column',gap:'1.2rem',
            }}>
              <p style={{ color:T.gold,fontSize:'0.7rem',letterSpacing:'0.2em',textTransform:'uppercase',fontWeight:'600',margin:0 }}>
                Call Back Request
              </p>

              <Field label="Full Name" icon="👤" error={errors.name}>
                <Input placeholder="Your full name" value={form.name} onChange={set('name')} />
              </Field>

              <Field label="Email Address" icon="✉" error={errors.email}>
                <Input placeholder="your@email.com" value={form.email} onChange={set('email')} type="email" />
              </Field>

              <Field label="Mobile Number" icon="📞" error={errors.phone}>
                <Input placeholder="e.g. 0212345678" value={form.phone} onChange={set('phone')} />
              </Field>

              <Field label="Message" icon="💬" error={errors.message}>
                <Textarea placeholder="How can we help you?" value={form.message} onChange={set('message')} />
              </Field>

              {/* OTP row */}
              {!otpVerified ? (
                <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
                  {!otpSent ? (
                    <button
                      onClick={handleSendOtp}
                      disabled={otpSending}
                      style={{
                        background:'transparent',border:`1px solid ${T.gold}`,color:T.gold,
                        padding:'10px',borderRadius:'5px',fontSize:'0.82rem',
                        fontWeight:'600',letterSpacing:'0.08em',textTransform:'uppercase',
                        cursor:'pointer',transition:'all 0.2s',
                        opacity: otpSending ? 0.6 : 1,
                      }}
                      onMouseEnter={e=>{ e.currentTarget.style.background=T.gold; e.currentTarget.style.color='#0d0d0d'; }}
                      onMouseLeave={e=>{ e.currentTarget.style.background='transparent'; e.currentTarget.style.color=T.gold; }}
                    >
                      {otpSending ? 'Sending OTP…' : 'Send OTP to Email'}
                    </button>
                  ) : (
                    <Field label="Enter OTP" icon="🔐" error={errors.otp}>
                      <div style={{ display:'flex',gap:'8px' }}>
                        <Input
                          placeholder="6-digit OTP"
                          value={form.otp}
                          onChange={set('otp')}
                          maxLength={6}
                          style={{ letterSpacing:'0.2em' }}
                        />
                        <button
                          onClick={handleVerifyOtp}
                          disabled={otpVerifying}
                          style={{
                            background:T.gold,border:'none',color:'#0d0d0d',
                            padding:'0 18px',borderRadius:'5px',fontSize:'0.8rem',
                            fontWeight:'700',letterSpacing:'0.06em',
                            cursor:'pointer',whiteSpace:'nowrap',flexShrink:0,
                            opacity: otpVerifying ? 0.6 : 1,
                          }}
                        >
                          {otpVerifying ? '…' : 'Verify'}
                        </button>
                      </div>
                      <button
                        onClick={handleSendOtp}
                        style={{ background:'none',border:'none',color:T.textMuted,fontSize:'0.75rem',cursor:'pointer',textAlign:'left',padding:0,marginTop:'2px' }}
                      >
                        Resend OTP
                      </button>
                    </Field>
                  )}
                </div>
              ) : (
                <div style={{
                  display:'flex',alignItems:'center',gap:'8px',
                  background:'rgba(80,200,120,0.08)',border:'1px solid rgba(80,200,120,0.25)',
                  borderRadius:'5px',padding:'10px 14px',
                }}>
                  <span style={{ color:'#6ee7a0',fontSize:'1rem' }}>✓</span>
                  <span style={{ color:'#6ee7a0',fontSize:'0.85rem',fontWeight:'600' }}>Email verified</span>
                </div>
              )}

              {serverError && (
                <div style={{ background:'rgba(220,60,60,0.1)',border:'1px solid rgba(220,60,60,0.3)',borderRadius:'5px',padding:'10px 14px',color:'#e87c7c',fontSize:'0.85rem' }}>
                  {serverError}
                </div>
              )}

              {/* Submit */}
              <button
                onClick={handleSubmit}
                disabled={!otpVerified || sending}
                style={{
                  background: otpVerified
                    ? `linear-gradient(135deg,${T.gold},${T.goldLight})`
                    : 'rgba(201,168,76,0.15)',
                  border:'none',
                  color: otpVerified ? '#0d0d0d' : 'rgba(201,168,76,0.4)',
                  padding:'13px',borderRadius:'5px',
                  fontSize:'0.88rem',fontWeight:'700',
                  letterSpacing:'0.08em',textTransform:'uppercase',
                  cursor: otpVerified ? 'pointer' : 'not-allowed',
                  transition:'opacity 0.2s',
                  opacity: sending ? 0.7 : 1,
                  display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',
                }}
              >
                {sending ? (
                  <>
                    <span style={{ width:'14px',height:'14px',border:'2px solid rgba(0,0,0,0.3)',borderTop:'2px solid #000',borderRadius:'50%',animation:'spin 0.7s linear infinite',display:'inline-block' }} />
                    Sending…
                  </>
                ) : 'Send Message →'}
              </button>
            </div>

            {/* ── RIGHT: Info + Map ── */}
            <div style={{ display:'flex',flexDirection:'column',gap:'1.2rem' }}>

              {/* Contact info cards */}
              {[
                { icon:'📍', label:'Address',  value:'3 Lord Kitchener St, Port Louis' },
                { icon:'✉',  label:'Email',    value:'info@orisnz.com' },
                { icon:'📞', label:'Phone',    value:'+230 XXX XXXX' },
              ].map(item => (
                <div key={item.label} style={{
                  background:T.bgCard,border:`1px solid ${T.border}`,
                  borderRadius:'8px',padding:'1.2rem 1.4rem',
                  display:'flex',alignItems:'center',gap:'1rem',
                }}>
                  <span style={{ fontSize:'1.4rem' }}>{item.icon}</span>
                  <div>
                    <p style={{ margin:0,color:T.textMuted,fontSize:'0.7rem',letterSpacing:'0.12em',textTransform:'uppercase',fontWeight:'600' }}>{item.label}</p>
                    <p style={{ margin:0,color:T.cream,fontSize:'0.92rem',marginTop:'3px' }}>{item.value}</p>
                  </div>
                </div>
              ))}

              {/* Map */}
              <div style={{ flex:1,minHeight:'220px',borderRadius:'8px',overflow:'hidden',border:`1px solid ${T.border}` }}>
                <iframe
                  title="Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7490.506038210261!2d57.495147999999986!3d-20.165187999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x217c504dde38da55%3A0x7d036787e7d18169!2s3%20Lord%20Kitchener%20St%2C%20Port%20Louis!5e0!3m2!1sen!2smu!4v1690538179654!5m2!1sen!2smu"
                  width="100%" height="100%"
                  style={{ border:0,display:'block',minHeight:'220px',filter:'grayscale(1) invert(0.85) contrast(0.9)' }}
                  allowFullScreen loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
          )}

          {/* Footer rule */}
          <div style={{ borderTop:`1px solid ${T.border}`,marginTop:'4rem',paddingTop:'1.5rem',textAlign:'center' }}>
            <span style={{ color:'rgba(201,168,76,0.35)',fontSize:'0.75rem',letterSpacing:'0.18em',textTransform:'uppercase' }}>
              Orisnz Fleet &mdash; Orisys Infotech Pvt. Ltd
              
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;